import { useCallback, useContext } from 'react';
import AlertsContext from '~/context/common/AlertsContext';
import { useIsNative } from '~/context/common/DeviceContext';
import FavoritesToastContent from './FavoritesToastContent';
import styles from './FavoritesToastContent.module.css';
import { ToastAction, ToastView } from './types';

const useDisplayFavoritesToast = () => {
  const { showToast } = useContext(AlertsContext);
  const isNative = useIsNative();

  return useCallback(
    (action: ToastAction, view?: ToastView) => {
      if (isNative) return;

      return showToast({
        className: styles.favoriteToast,
        label: <FavoritesToastContent action={action} view={view} />,
        lifetime: 6000,
        position: 'top-center',
        severity: 'custom',
        showClose: false
      });
    },
    [isNative, showToast]
  );
};

export default useDisplayFavoritesToast;
